/**
 * PeriodType Enum - Based on PeriodType.java
 * Types of subscription periods
 */
export enum PeriodType {
  SESSION = 'SESSION',
  WEEK = 'WEEK',
  BI_WEEKS = 'BI_WEEKS',
  MONTH = 'MONTH',
  THREE_MONTHS = 'THREE_MONTHS',
  SEMESTER = 'SEMESTER',
  YEAR = 'YEAR',
  OTHER = 'OTHER',
}

/**
 * Labels for period types in Spanish
 */
export const PERIOD_TYPE_LABELS: Record<PeriodType, string> = {
  [PeriodType.SESSION]: 'SESIÓN',
  [PeriodType.WEEK]: 'SEMANA',
  [PeriodType.BI_WEEKS]: 'QUINCENA',
  [PeriodType.MONTH]: 'MENSUALIDAD',
  [PeriodType.THREE_MONTHS]: 'TRIMESTRE',
  [PeriodType.SEMESTER]: 'SEMESTRE',
  [PeriodType.YEAR]: 'ANUALIDAD',
  [PeriodType.OTHER]: 'OTRO',
};
